import { get } from './http'

const getApiUrl = protocolName => {
    const hostname = process.env.NODE_ENV === 'development' ? 'localhost:8080' : location.hostname
    console.log('hostname ==>>', hostname)
    if( process.env.NODE_ENV === 'development'){
        return "http://localhost:8080"
    }else if(process.env.NODE_ENV === 'production'){
        if( hostname === 'sandbox.fastorder.my'){
            return "https://sb-api.fastorder.my"
        }else {
            return "https://api.fastorder.my"
        }
    }
}

const apiBasicUrl = getApiUrl(document.location.protocol.toLowerCase())

//https://sb-api.fastorder.my/fomy/v2/store/${storeId}/business/hour?type=DELIVERY
export const getApiBusinessHour = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)


//https://sb-api.fastorder.my/fomy/v2/store/1
export const getApiServicesType = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)

// https://sb-api.fastorder.my/fomy/v2/store/1/order/1223
export const getApiFindDriver = (apiName, apiParams) => get(apiBasicUrl + apiName, apiParams)